import { put } from 'redux-saga/effects';
import actions from '../../../../../actions';
import signedFetch from '../../../../apiCalls/util/signedFetch';

export const StatusEnum = {
  Error: 'error',
  InProgress: 'inProgress',
  Success: 'Success'
};

function* getMigrateOrgData(input) {
  const { orgId } = input;
  let completedSuccessfully = true;
  yield put(actions.migrateOrgInProgress(StatusEnum.InProgress));

  const result = yield signedFetch(
    'migrateMembershipsMongo',
    `${__API_BASE__}/org/${orgId}/migrate-memberships-mongo`,
    'POST'
  );

  let errorResult = {};
  if (!result.status || result.status === 'error' || result.status === 'fail') {
    completedSuccessfully = false;
    errorResult = { ...result, orgId };
  }

  if (completedSuccessfully) {
    yield put(actions.migrateOrgSuccess(StatusEnum.Success));
  } else {
    yield put(actions.migrateOrgFailure({ status: StatusEnum.Error, errorResult }));
  }
}

export default getMigrateOrgData;
